import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-5 w-9/12" }
const _hoisted_3 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-5" }
const _hoisted_4 = { class: "text-center" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import TabComponent from '@/components/TabComponent.vue';
import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import PagePagination from '@/components/PagePagination.vue';
import { paginatePage } from '@/helpers/PageHelper';
import RolePermissionService from '@/classes/RolePermissionService';

import { useRouter } from 'vue-router';
import { ref, onMounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();

// Data
const loader    = ref(false);
const showError = ref(false);
const errorMsg  = ref(null);

// const activeTab  = ref();
const goToPage   = ref();

// Page Renderer Data
const items           = ref(null);
const items_count     = ref(null);
const rows            = ref(null);
const query           = ref(null);
const filterDate       = ref(null);
const active_count    = ref(0);


const tabs: { name: string, count: number, href: string, allowed: boolean }[] = [
    {
        name: 'Active',
        href: '/accounts/roles',
        count: active_count.value,
        allowed: true
    }
];

const headers: { text: string }[] = [
    { text: 'Roles' },
    { text: 'Date Created'}
];

// Methods
const indexRoles = (data: string) => {
    loader.value = true;

    goToPage.value = paginatePage(data)

    RolePermissionService.indexRole(goToPage.value)
        .then((response: any) => {
            loader.value          = false;
            items.value           = response.data.items;
            items_count.value     = response.data.items_count
            rows.value            = response.data.rows
            query.value           = response.data.query
            filterDate.value       = response.data.filterDate
            active_count.value    = response.data.active_count
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

// const sampleData: { id: number, role: string, dateCreated: string }[] = [
//     {
//         id: 1,
//         role: 'Super Admin',
//         dateCreated: 'Jan 5, 2023 (00:00:00)',
//     },
//     {
//         id: 2,
//         role: 'Contact Center Admin',
//         dateCreated: 'Jan 5, 2023 (00:00:00)',
//     },
//     {
//         id: 3,
//         role: 'Web Booking Admin',
//         dateCreated: 'Jan 5, 2023 (00:00:00)',
//     },
//     {
//         id: 4,
//         role: 'Corporate Account Admin',
//         dateCreated: 'Jan 5, 2023 (00:00:00)',
//     },
//     {
//         id: 5,
//         role: 'CMS Admin',
//         dateCreated: 'Jan 5, 2023 (00:00:00)',
//     },
// ];

onMounted(() => { indexRoles(goToPage.value) })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, { title: "Roles" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, {
          tabs: tabs,
          "button-items": true
        })
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(DataTable, {
          headers: headers,
          count: items.value?.data.length
        }, {
          body: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value?.data, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_2, _toDisplayString(item.name), 1),
                _createElementVNode("td", _hoisted_3, _toDisplayString(item.created_at), 1),
                _createElementVNode("td", _hoisted_4, [
                  _createVNode(ActionButton, {
                    "edit-btn": "",
                    onClick: ($event: any) => (_unref(router).push(`/accounts/roles/show/${item.id}`))
                  }, null, 8, ["onClick"])
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["count"]),
        _createVNode(PagePagination, {
          class: "mb-6",
          items: items.value,
          onNextPage: indexRoles
        }, null, 8, ["items"])
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[1] || (_cache[1] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})